export default {
	popup:      state => state.popup,
	popupTitle: state => state.popupTitle,
	timer:      state => state.timer
};
